import React, { useState } from 'react';
import { Facebook, Linkedin, MessageCircle, Link2, Check } from 'lucide-react';

/**
 * Lightweight social share row (no SDKs, no keys).
 * Channels popular in PH: Facebook, X, LinkedIn, WhatsApp, Viber, Copy link.
 */
const ShareButtons = ({ title = '', label = 'Share', className = '', testId }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const eu = encodeURIComponent(url);
  const et = encodeURIComponent(title);

  const links = [
    { key: 'facebook', label: 'Facebook', href: `https://www.facebook.com/sharer/sharer.php?u=${eu}`, icon: Facebook },
    { key: 'x', label: 'X', href: `https://twitter.com/intent/tweet?url=${eu}&text=${et}`, icon: null },
    { key: 'linkedin', label: 'LinkedIn', href: `https://www.linkedin.com/sharing/share-offsite/?url=${eu}`, icon: Linkedin },
    { key: 'whatsapp', label: 'WhatsApp', href: `https://wa.me/?text=${et}%20${eu}`, icon: MessageCircle },
    { key: 'viber', label: 'Viber', href: `viber://forward?text=${et}%20${eu}`, icon: null },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`} data-testid={testId}>
      <span className="text-white/40 text-xs font-mono uppercase tracking-wider mr-1">{label}</span>
      {links.map(({ key, label: l, href, icon: Icon }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Share on ${l}`}
          title={`Share on ${l}`}
          data-testid={`share-${key}`}
          className="w-8 h-8 flex items-center justify-center rounded-full border border-white/15 text-white/70 hover:text-[#00FFD1] hover:border-[#00FFD1]/50 transition-colors"
        >
          {Icon ? <Icon size={15} /> : <span className="text-xs font-bold">{key === 'x' ? '𝕏' : 'V'}</span>}
        </a>
      ))}
      <button
        type="button"
        onClick={copy}
        aria-label="Copy link"
        title="Copy link"
        data-testid="share-copy"
        className="w-8 h-8 flex items-center justify-center rounded-full border border-white/15 text-white/70 hover:text-[#00FFD1] hover:border-[#00FFD1]/50 transition-colors"
      >
        {copied ? <Check size={15} className="text-[#00FFD1]" /> : <Link2 size={15} />}
      </button>
    </div>
  );
};

export default ShareButtons;
